// extracted by mini-css-extract-plugin
module.exports = {"unlocked":"api-users-table_unlocked__4MA4i","locked":"api-users-table_locked__2C8TZ"};